// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productPriceStyles } from "@pace/Overrides/Components/ProductPrice";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

productPriceStyles.priceLabelText = {
    variant: "p",
    css: css`
        font-size: 12px;
        letter-spacing: 0;
        line-height: 13px;
        margin-bottom: 4px;
        display: none;
        ${xScreen("lt", "md")} {
            display: block;
        }
    `,
};

productPriceStyles.price = {
    salePriceLabel: {
        size: 12,
        lineHeight: "17px",
        weight: fontConfig.weight.regular,
        css: css`
            display: block;
        `,
    },
    priceText: {
        variant: "h5",
        forwardAs: "p",
        css: css`
            margin-bottom: 0;
            display: inline-block;
        `,
    },
    unitOfMeasure: {
        unitOfMeasureText: {
            size: 12,
            lineHeight: "13px",
            css: css`
                margin-left: 4px;
            `,
        },
    },
    errorText: {
        css: css`
            font-size: 12px;
            line-height: 13px;
            font-weight: ${fontConfig.weight.bold};
        `,
    },
};

productPriceStyles.invalidPriceText = {
    color: "danger",
    css: css`
        margin-bottom: 10px;
    `,
};